import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BasicTextArea, BaasicButton } from 'core/components';

function FacilityOrderTemplateItemNewFlowNoteModalTemplate({ facilityOrderTemplateItemNewFlowNoteModalStore , t}) {
    const {
        facilityOrderTemplateItem,
        form,
        modalParams
    } = facilityOrderTemplateItemNewFlowNoteModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>{facilityOrderTemplateItem.product.description}</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    <BasicTextArea field={form.$('note')} />
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
                <BaasicFormControls
                    form={form} 
                    onSubmit={form.onSubmit} 
                    disabled={form.submitting || form.validating} 
                    label="Submit"
                    className='btn btn--med btn--primary'
                />
            </div>
        </section>
    )
}
 
FacilityOrderTemplateItemNewFlowNoteModalTemplate.propTypes = {
    facilityOrderTemplateItemNewFlowNoteModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderTemplateItemNewFlowNoteModalTemplate);
